import { Regions } from 'common/model/account/regions';
import React from 'react';

export const vostokMaxBotLink = 'https://max.ru/id7705424509_2_bot';
export const chatWootMaxLinkSelector = '.circle-menu__item.max';
export const chatWootItemsListSelector = '.circle-menu__list';
export const chatWootBaseChatBtnSelector = '.circle-menu__item.chat.text-page__btn-chat';
export const chatWootBaseChatBtnPositions = {
    WHEN_NOT_ALONE: '-102px',
    WHEN_SINGLE: '-50px',
};

export const ContentTitles = {
    USER_ANSWER_LABEL: 'USER_ANSWER_LABEL',
} as const;

export type ContentTitle = keyof typeof ContentTitles;

export type TContentWithTitle = Record<ContentTitle, React.ReactNode>;

type TRegionContent = Partial<Record<Regions, TContentWithTitle>>;

export const contentByRegionMap: TRegionContent = {
    [Regions.NRIC]: {
        [ContentTitles.USER_ANSWER_LABEL]: 'Дополнительная информация о лицевом счете: введите фамилию клиента или последние 4 цифры серийного номера прибора учета в помещении.'
    },
    [Regions.TjumenskajaOblast]: {
        [ContentTitles.USER_ANSWER_LABEL]: 'Дополнительная информация о лицевом счете: введите фамилию абонента или последние 4 цифры серийного номера прибора учета в помещении.'
    }
};
